export default "__VITE_ASSET__DySrd2c5__"